import { render, staticRenderFns } from "./RenegotiationForm.vue?vue&type=template&id=32b2865a&"
import script from "./RenegotiationForm.vue?vue&type=script&lang=js&"
export * from "./RenegotiationForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports